import { Component } from '@angular/core';

@Component({
    selector: 'my-account-subscriptions-skeleton',
    templateUrl: './my-account-subscriptions-skeleton.component.html',
    styleUrl: './my-account-subscriptions-skeleton.component.scss',
    standalone: false
})
export class MyAccountSubscriptionsSkeletonComponent {

}
